import SectionHeading from '@/components/feature/SectionHeading';
import { watchGuide } from '@/mocks/categories';

export default function WatchGuide() {
  return (
    <section id="guide" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <SectionHeading
        eyebrow="追更指南"
        title="四步看懂本站更新"
        description="第一次访问也不用摸索，按下面的顺序走一遍，基本就能把当天值得看的内容挑出来。"
      />

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {watchGuide.map((item) => (
          <article
            key={item.id}
            className="relative rounded-lg border border-background-200 bg-background-50 p-5 flex flex-col"
          >
            <span className="font-heading text-3xl md:text-4xl font-black text-accent-400 leading-none">{item.step}</span>
            <h3 className="font-heading mt-4 text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-700 flex-1">{item.desc}</p>
            <i
              className="ri-arrow-right-line absolute top-5 right-5 text-background-300 hidden lg:block"
              aria-hidden="true"
            ></i>
          </article>
        ))}
      </div>
    </section>
  );
}